/**
 * @generated SignedSource<<d741568e74a9e454c55bbeb58f4cc71c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateTravelDocumentInput = {
  name?: string | null;
};
export type TravelDocumentEditFormMutation$variables = {
  id: string;
  input: UpdateTravelDocumentInput;
};
export type TravelDocumentEditFormMutation$data = {
  readonly updateTravelDocument: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "TravelDocumentEditForm_document">;
  };
};
export type TravelDocumentEditFormMutation = {
  response: TravelDocumentEditFormMutation$data;
  variables: TravelDocumentEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelDocumentEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TravelDocument",
        "kind": "LinkedField",
        "name": "updateTravelDocument",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TravelDocumentEditForm_document"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TravelDocumentEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TravelDocument",
        "kind": "LinkedField",
        "name": "updateTravelDocument",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "146fc3ec6a15e0870ec101df424310d2",
    "id": null,
    "metadata": {},
    "name": "TravelDocumentEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation TravelDocumentEditFormMutation(\n  $id: ID!\n  $input: UpdateTravelDocumentInput!\n) {\n  updateTravelDocument(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...TravelDocumentEditForm_document\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment TravelDocumentEditForm_document on TravelDocument {\n  id\n  name\n}\n"
  }
};
})();

(node as any).hash = "2528de0c61b4d3925cf93a78d4aad914";

export default node;
